export const part2Vocabulary = [
  {
    id: 1,
    expression: "Would you take a look at this report?",
    meaning: "이 보고서를 검토해 주시겠습니까?",
    audioId: "vocab_1",
    example: "Would you take a look at this report?",
    translation: "이 보고서를 검토해 주시겠습니까?",
  },
  
];
